<template>
    <Modal :id="'Mapa_Clientes'" :size="''" :open="show" :FooterDefault="false">

        <template v-slot:header>

            <h6 class="modal-title">Mapa Clientes</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times btn-close-style"></i></button>

        </template>

        <template v-slot:body>

            <GMapMap ref="xyz" :center="local" :zoom="4" map-type-id="terrain" style="width: 100%; height:calc(100vh - 160px)">
                <GMapMarker :key="index"
                            v-for="(m, index) in markers"
                            :position="m.position"
                            :icon="pin_truck"
                            :clickable="true"
                            :draggable="false" />
            </GMapMap>



        </template>

        <template v-slot:footer>
            <div class="modal-footer">
                <button type="button" class="btn btn-close-clean-v2 mt-2"
                        data-bs-dismiss="modal">
                    Fechar
                </button>
                <button type="submit" class="btn btn-red-v2" form="form" v-on:click="submitForm">Concluir</button>
            </div>
        </template>

    </Modal>

</template>

<script>

    import axios from 'axios';
    import Modal from '@/components/App/Modal.vue';

    export default {
        name: 'MapaCliente',
        components: {
            Modal
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
            nrMetros: {
                type: Number,
                default: 0
            },
            idInstituicao: {
                type: Number,
                default: 0
            },
            idModulo: {
                type: Number,
                default: 0
            },
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                flCliente: 'Sim',
                flAtivo: 'Sim',
                zoomLevel: 17,
                local: { lat: -15.7801, lng: -47.9292 },
                markers: [],
            }
        },
        methods: {
            getCliente() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Instituicao/Cliente?idInstituicao=' + $this.idInstituicao + "&idModulo=" + $this.idModulo + "&nrMetros=" + $this.nrMetros + "&flCliente=" + $this.flCliente + "&flAtivo=" + $this.flAtivo, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.markers = response.data.data;
                    console.log($this.markers)
                });
            },
        },
        mounted() {
            this.getCliente();
        },
        watch: {
        }
    }

</script>

<style scoped>
</style>